import is from 'is_js';
import * as settings from '../globals/settings';
import { createError } from '../util/error';

// Config!
// FIXME This is a secret and it should not be stored in config.
const apiToken = settings.API_TOKEN;
const baseUrl = settings.API_URL;
const apiTokenHeader = 'X-VSF-API-Token';
const AuthorizationHeader = 'Authorization';

export const ACCESS_DENIED_ERROR_CODE = 'ADE';
export const AUTHENTICATION_REQUIRED_ERROR_CODE = 'ARE';
export const SERVICE_INTERRUPTION_ERROR_CODE = 'SIE';
export const USERNAME_EXISTS_EXCEPTION_CODE = 'UNAE';
export const INVALID_PASSWORD_EXCEPTION_CODE ='IPE';
export const MISSING_IDENTIFIER_ERROR_CODE = 'MIE';
export const INVALID_ITEM_EXCEPTION_CODE ='IIE';
export const CREATE_USER_EXCEPTION_CODE ='CUE';
export const NO_SOURCE_ID_ERROR_CODE = 'LREE';
export const DATA_ACCESS_ERROR_CODE = 'DAE';
export const UNKNOWN_ERROR_CODE = 'UE';
export const INVALID_DEPENDANT_ERROR = 'IDE';
export const FACILITY_NUMBER_MESSAGE_ID_ERROR = 'IRLE';
export const HIAL_TIMEOUT_CODE = 'HTO';
export const QR_CODE_ERROR = 'QRCE';
export const IIABE_ERROR = 'IIABE';
export const INVALID_REGISTRATION_CODE_D = '013';
export const INVALID_REGISTRATION_CODE_E = '014';
export const INVALID_REGISTRATION_CODE_F = '015';
export const INVALID_REG_NUM_EXCEPTION_CODE = '101';
export const INVALID_HCN_ISSUER_EXCEPTION_CODE = '102';
export const INVALID_HCN_EXCEPTION_CODE = '103';
export const INVALID_LN_EXCEPTION_CODE = '104';
export const INVALID_HCN_EXPIRY_EXCEPTION_CODE = '106';
export const INVALID_DOB_EXCEPTION_CODE = '107';
export const INVALID_DOB_U16_EXCEPTION_CODE = '111';
export const INVALID_FN_EXCEPTION_CODE = '112';
export const INVALID_REGISTRATION_CODE_A = '113';
export const INVALID_REGISTRATION_CODE_B = '114';
export const INVALID_REGISTRATION_CODE_C = '115';
export const HIAL_INVALID_LANGUAGE_CODE = '803';
export const NO_IMMUNIZATION_RESULT_RECORD_CODE = '804';
export const NO_IMMUNIZATION_RECORD_CODE = '805';
export const NO_PATIENT_DATA_CODE = '806';
export const NO_VACCINATION_STATUS_RESULT_CODE = '904';
export const NO_VACCINATION_STATUS_CODE = '905';
export const VACCINATION_STATUS_MISSING_PATIENT_DATA_CODE = '906';
export const NO_VACCINATION_CREDENTIALS_CODE = '907';
export const SOAP_FAULT_EXCEPTION_CODE = '999';
export const SALESFORCE_EMBED_EXCEPTION_CODE = 'SFEE';

function timeout(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      reject(new Error("Network connection timeout"))
    }, ms)
    promise.then(resolve, reject)
  })
}

export function getResults(userId, language, deviceId, authorizationToken){
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken; 
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }

    let finalUrl = baseUrl + "v1/results/";

    if(userId!==null && userId!==undefined){
        finalUrl +="?user_id=" +userId;
    }
    return timeout(settings.HIAL_TIMEOUT, fetch(encodeURI(finalUrl), data));
}

export function getImmunizationResults(userId, language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/immunization/';
    if(userId!==null && userId!==undefined){
        finalUrl +="?user_id=" +userId;
    }
    return timeout(settings.HIAL_TIMEOUT, fetch(encodeURI(finalUrl), data));
}

export function getVaccinationStatus(userId, language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    }
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/immunization/status'
    if (userId !== null && userId !== undefined) {
        finalUrl += "?user_id=" + userId;
    }
    return timeout(settings.HIAL_TIMEOUT, fetch(encodeURI(finalUrl), data))
}

export function authenticate(openIdVars, language, deviceId) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    let nonce = openIdVars.nonce;
    let codeVerifier = openIdVars.codeVerifier;
    let authorizationCode = openIdVars.authorizationCode;
    headerData[apiTokenHeader] = apiToken; 
    var headers = new Headers(headerData);
    var bodyData = {
        type: "oidc_authorization_registration_flow",
        credentials: {
            authorizationCode: authorizationCode,
            codeVerifier: codeVerifier,
            nonce: nonce,
        }
    };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    //let finalUrl = baseUrl + 'login';
    let finalUrl = baseUrl + 'v1/authentication/login';
    return fetch(encodeURI(finalUrl), data);
}

export function logOut(language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'DELETE', headers: headers }
    let finalUrl = baseUrl + 'v1/authentication/logout/';
    return fetch(encodeURI(finalUrl), data);
}

// FIXME This is hardcoded, should probably not be hard coded
function makeVersion() {
    let deviceType;
    if(is.desktop()){
        deviceType = 'Desktop';
    } else if(is.mobile()){
        deviceType = 'Mobile';
    } else {
        deviceType = 'Tablet';
    }
    return settings.VSF_CLIENT_NAME + '-' + settings.VERSION + '-' + deviceType;
}

// FIXME Internet explorer apparently does not support response.status!
export function handleLoginErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null};

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE) {
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 404 && json.error.exception === MISSING_IDENTIFIER_ERROR_CODE) {
        error = createError(MISSING_IDENTIFIER_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === NO_SOURCE_ID_ERROR_CODE) {
        error = createError(NO_SOURCE_ID_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === DATA_ACCESS_ERROR_CODE) {
        error = createError(DATA_ACCESS_ERROR_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handleRegisterErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null, message: null };

    let errorMessage = null;
    if (json != null && json.error != null && json.error.message != null) {
        errorMessage = json.error.message;
    }

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null, errorMessage);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 400 && json.error.exception === INVALID_ITEM_EXCEPTION_CODE) {
        error = createError(INVALID_ITEM_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === CREATE_USER_EXCEPTION_CODE) {
        error = createError(CREATE_USER_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === INVALID_REGISTRATION_CODE_D) {
        error = createError(INVALID_REGISTRATION_CODE_D, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === INVALID_REGISTRATION_CODE_E) {
        error = createError(INVALID_REGISTRATION_CODE_E, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === INVALID_REGISTRATION_CODE_F) {
        error = createError(INVALID_REGISTRATION_CODE_F, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_REG_NUM_EXCEPTION_CODE){
        error = createError(INVALID_REG_NUM_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_HCN_ISSUER_EXCEPTION_CODE){
        error = createError(INVALID_HCN_ISSUER_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_HCN_EXCEPTION_CODE){
        error = createError(INVALID_HCN_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_LN_EXCEPTION_CODE){
        error = createError(INVALID_LN_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_HCN_EXPIRY_EXCEPTION_CODE){
        error = createError(INVALID_HCN_EXPIRY_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_DOB_EXCEPTION_CODE){
        error = createError(INVALID_DOB_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_DOB_U16_EXCEPTION_CODE){
        error = createError(INVALID_DOB_U16_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === INVALID_FN_EXCEPTION_CODE){
        error = createError(INVALID_FN_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === INVALID_REGISTRATION_CODE_A) {
        error = createError(INVALID_REGISTRATION_CODE_A, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === INVALID_REGISTRATION_CODE_B) {
        error = createError(INVALID_REGISTRATION_CODE_B, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === INVALID_REGISTRATION_CODE_C) {
        error = createError(INVALID_REGISTRATION_CODE_C, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === SOAP_FAULT_EXCEPTION_CODE){
        error = createError(SOAP_FAULT_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE) {
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if(statusCode === 500 && json.error.exception === DATA_ACCESS_ERROR_CODE){
        error = createError(DATA_ACCESS_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === NO_IMMUNIZATION_RESULT_RECORD_CODE) {
        error = createError(NO_IMMUNIZATION_RESULT_RECORD_CODE, statusCode, errorId, errorMessage);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId, errorMessage);
    }
    return error;
} // INVALID_DEPENDANT_ERROR

// FIXME What are the error codes here?
export function handleLogoutErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null };

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE) {
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

//Check getResultsErrors if there are any then we will throw them
export function handleGetResultsErrors(statusCode, json){
    let error = { error: false, code: null, statusCode: null, id: null, message: null };

    let errorMessage = null;
    if (json != null && json.error != null && json.error.message != null) {
        errorMessage = json.error.message;
    }

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null, errorMessage);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE){
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === SOAP_FAULT_EXCEPTION_CODE) {
        error = createError(SOAP_FAULT_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 504 && json.error.exception === HIAL_TIMEOUT_CODE) {
        error = createError(HIAL_TIMEOUT_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === HIAL_INVALID_LANGUAGE_CODE) {
        error = createError(HIAL_INVALID_LANGUAGE_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handleGetImmunizationErrors(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null, message: null };

    let errorMessage = null;
    if (json != null && json.error != null && json.error.message != null) {
        errorMessage = json.error.message;
    }

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null, errorMessage);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE){
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === NO_IMMUNIZATION_RECORD_CODE) {
        error = createError(NO_IMMUNIZATION_RECORD_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === NO_IMMUNIZATION_RESULT_RECORD_CODE) {
        error = createError(NO_IMMUNIZATION_RESULT_RECORD_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === NO_PATIENT_DATA_CODE) {
        error = createError(NO_PATIENT_DATA_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === SOAP_FAULT_EXCEPTION_CODE) {
        error = createError(SOAP_FAULT_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === HIAL_INVALID_LANGUAGE_CODE) {
        error = createError(HIAL_INVALID_LANGUAGE_CODE, statusCode, errorId);
    } else if (statusCode === 504 && json.error.exception === HIAL_TIMEOUT_CODE) {
        error = createError(HIAL_TIMEOUT_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function handleGetVaccinationStatusError(statusCode, json) {
    let error = { error: false, code: null, statusCode: null, id: null, message: null }

    let errorMessage = null
    if (json != null && json.error != null && json.error.message != null) {
        errorMessage = json.error.message;
    }

    if (json == null) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null, errorMessage);
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200 && json.success === true) {
        // Do nothing!
        ;;
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE){
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === NO_VACCINATION_STATUS_RESULT_CODE) {
        error = createError(NO_VACCINATION_STATUS_RESULT_CODE,statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === NO_VACCINATION_STATUS_CODE) {
        error = createError(NO_VACCINATION_STATUS_CODE,statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === VACCINATION_STATUS_MISSING_PATIENT_DATA_CODE) {
        error = createError(VACCINATION_STATUS_MISSING_PATIENT_DATA_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === SOAP_FAULT_EXCEPTION_CODE) {
        error = createError(SOAP_FAULT_EXCEPTION_CODE, statusCode, errorId);
    } else if (statusCode === 504 && json.error.exception === HIAL_TIMEOUT_CODE) {
        error = createError(HIAL_TIMEOUT_CODE, statusCode, errorId);
    } else {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId);
    }
    return error;
}

export function register(dto, language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var bodyData = { dependantDto: dto };
    var data = { method: 'POST', headers: headers, body: JSON.stringify(bodyData) }
    let finalUrl = baseUrl + 'v1/dependants/';
    return fetch(encodeURI(finalUrl), data);
}

function parseAuthorization(str) {
    return str.substring(7);
}

export function getAuthorizationToken(response) {
    let headers = response.headers;
    if (headers.get(AuthorizationHeader) != null) {
        return parseAuthorization(headers.get(AuthorizationHeader));
    }
    return null;
}

    /*module.exports = {
    getLab: getLab,
    //ACCESS_DENIED_ERROR_CODE: ACCESS_DENIED_ERROR_CODE,
    //SERVICE_INTERRUPTION_ERROR_CODE: SERVICE_INTERRUPTION_ERROR_CODE,
    //MISSING_IDENTIFIER_ERROR_CODE: MISSING_IDENTIFIER_ERROR_CODE,
    authenticate: authenticate,
    logOut: logOut,
    determineLogoutStatus: determineLogoutStatus,
    getAuthorizationToken: getAuthorizationToken,
    //checkStatus: checkStatus,
}*/

export function getDemographics(language, deviceId, authorizationToken){
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    console.log(headerData);
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/demographics/';
    return timeout(settings.HIAL_TIMEOUT, fetch(encodeURI(finalUrl), data));
}

export function getDependants(language, deviceId, authorizationToken){
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/dependants/';
    return timeout(settings.HIAL_TIMEOUT, fetch(encodeURI(finalUrl), data));
}
export function tempAuthenticate(language, deviceId) {
    return new Promise((resolve, reject) => {
        let response = "Bearer eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIzNzQ2M2NjOC03MWU3LTRiY2ItOGViMi0zZTQ1MDk0ZmRhMmEiLCJpc3MiOiJ2c2YiLCJleHAiOjE2MDIwOTgyNDMsInVzZXJJZCI6IjM3NDYzY2M4LTcxZTctNGJjYi04ZWIyLTNlNDUwOTRmZGEyYSIsImlhdCI6MTYwMjA5NzA0M30.Xz9CnOnQ8LCXGQWWAgffpQc_tqcSRxjcO-Veah-MoNoW7RvbkqEemq6TG6nbDVqh6SNFXjzj27oqTKLLCxitrSTB4ubB9Tiyq8WrYJxEHeQG3mUE1p1naks7FhmA6hN4-NWG-tobnoJx8WqtVQ6HW4zLer9Qopw_URp3-TXXLBRSsD6shYyOe4y4T1tmPW6R5xq2iKQ0UuhFD2tUlDY76WurIu8Ub-JKznvZLsz73nJH5RsFO34Ym-XytN-s22uSZeKfNoEs_0mGJHzw_CPOVU60ILzOpkH_NDOju_oxoYpN1EZ6m3aoe5gyPNn0yjhmZ0TOx6OUzMjjq7Wj4Bnh3A";
         // We call resolve(...) when what we were doing asynchronously was successful, and reject(...) when it failed.
         // In this example, we use setTimeout(...) to simulate async code. 
         // In reality, you will probably be using something like XHR or an HTML5 API.
         setTimeout( function() {
           resolve(response)  // Yay! Everything went well!
         }, 250) 
     })
 }

export function getResultsPDF(language, deviceId, authorizationToken, messageId, facilityNumber, resultDate, userId){
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/results/pdf?message_id=';
    finalUrl += messageId + "&facility_number=" + facilityNumber + "&result_date=" + resultDate;
    if(userId!==null  && userId!==undefined){
        finalUrl += "&user_id="+userId;
    }
    return timeout(settings.GATEWAY_TIMEOUT, fetch(encodeURI(finalUrl), data).then((response) =>{
        return response;
    }));
}

//TODO FIX THIS TO ACTUALLY USE ERRORS TYPE OF RESPONSE seems to prevent this
export function handleGetPDFErrors(statusCode, json, length, contentType, strings){
    let error = { error: false, code: null, statusCode: null, id: null, message: null };
    let errorMessage = null;
    if (json != null && json.error != null && json.error.message != null) {
        errorMessage = json.error.message;
    }


    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if(length === 0 && contentType==="application/json;charset=UTF-8"){
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId, strings.PDF_ERROR_MESSAGE);
    } else if (statusCode === 200) {
        // Do nothing!
        ;;
    } else if (statusCode === 500){
        error = createError(FACILITY_NUMBER_MESSAGE_ID_ERROR, statusCode, errorId, strings.PDF_ERROR_MESSAGE);
    } else if (statusCode === 401) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 403) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId, errorMessage);
    } else{
        error = createError(UNKNOWN_ERROR_CODE, statusCode, null);
    }
    return error;
}

export function getPVCPDF(language, deviceId, authorizationToken, userId){
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;

    let headers = new Headers(headerData);
    let data = { method: 'GET', headers: headers }
    let finalUrl = baseUrl + 'v1/immunization/passport';
    if(userId!==null  && userId!==undefined){
        finalUrl+='?user_id='+userId;
    }
    return timeout(settings.HIAL_TIMEOUT, fetch(encodeURI(finalUrl), data));
}

export function handlePVCPDFErrors(statusCode, json, length, contentType, strings){
    let error = { error: false, code: null, statusCode: null, id: null, message: null };
    let errorMessage = null;

    if (json != null && json.error != null && json.error.message != null) {
        errorMessage = json.error.message;
    }

    let errorId = null;
    if (json != null && json.error != null && json.error.id != null) {
        errorId = json.error.id;
    }

    if (statusCode === 200) {
        // Do nothing!
        ;;
    } else if(length === 0 && contentType==="application/json;charset=UTF-8"){
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId, strings.PDF_ERROR_MESSAGE);
    } else if (statusCode === 403 && json.error.exception === ACCESS_DENIED_ERROR_CODE) {
        error = createError(ACCESS_DENIED_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 401 && json.error.exception === AUTHENTICATION_REQUIRED_ERROR_CODE) {
        error = createError(AUTHENTICATION_REQUIRED_ERROR_CODE, statusCode, errorId);
    } else if (statusCode === 500 && json.error.exception === QR_CODE_ERROR) {
        error = createError(QR_CODE_ERROR, statusCode, errorId, strings.QRCE_ERROR_MESSAGE);
    } else if (statusCode === 500 && json.error.exception === IIABE_ERROR) {
        error = createError(IIABE_ERROR, statusCode, errorId, strings.IIABE_ERROR_MESSAGE);
    } else if (statusCode === 500 && json.error.exception === DATA_ACCESS_ERROR_CODE) {
        error = createError(DATA_ACCESS_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === NO_VACCINATION_STATUS_RESULT_CODE) {
        error = createError(NO_VACCINATION_STATUS_RESULT_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === NO_VACCINATION_STATUS_CODE) {
        error = createError(NO_VACCINATION_STATUS_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === NO_VACCINATION_CREDENTIALS_CODE) {
        error = createError(NO_VACCINATION_CREDENTIALS_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 500 && json.error.exception === SOAP_FAULT_EXCEPTION_CODE) {
        error = createError(SOAP_FAULT_EXCEPTION_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 401 && json.error.exception === UNKNOWN_ERROR_CODE) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId, errorMessage);
    } else if (statusCode === 400 && json.error.exception === UNKNOWN_ERROR_CODE) {
        error = createError(UNKNOWN_ERROR_CODE, statusCode, errorId, errorMessage);
    } else{
        error = createError(UNKNOWN_ERROR_CODE, statusCode, strings.PDF_ERROR_MESSAGE);
    }
    return error;
}

export function updateTermsOfUse(acceptedTermsVersion, language, deviceId, authorizationToken) {
    var headerData = {
        "Content-Type": "application/json",
        "Accept-Language": language,
        "X-VSF-Client-Version": makeVersion(),
        "X-VSF-META-Device-Id": deviceId,
    };
    headerData[apiTokenHeader] = apiToken;
    headerData[AuthorizationHeader] = "Bearer " + authorizationToken;
    var headers = new Headers(headerData);
    var bodyData = { acceptedTermsVersion: acceptedTermsVersion };
    var data = { method: 'PATCH', headers: headers, body: JSON.stringify(bodyData) }
    let finalUrl = baseUrl + 'v1/demographics/';
    return fetch(encodeURI(finalUrl), data);
}